//for live form validation...
import {LiveForm, Nette} from "live-form-validation";

LiveForm.setOptions({
    messageErrorPrefix: "",
    messageParentClass: "form-group",
    wait: 500,
    showValid: true,
    controlValidClass: "is-valid",
    messageErrorClass: "help-block help-block--alert",
    controlErrorClass: "invalid",
    disableLiveValidationClass: "no-validation"
});

Nette.initOnLoad();
window.Nette = Nette;
window.LiveForm = LiveForm;

export function showErrors(){
    let errorElements = document.getElementsByClassName("input-error");

    for(let errorElement of errorElements){
        let inputElement = document.getElementById(errorElement.getAttribute("data-input"));

        if(inputElement) {
            LiveForm.addError(inputElement, errorElement.textContent);
        }
    }
}
